<template>
  <div>
    <popup-warp v-model="currentValue" backgroundColor="rgba(255, 255, 255, 0)">
      <div class="login-popup-warp">
        <div class="login-popup-block"></div>
        <div class="login-popup-types">
          <div class="login-popup-type">
            <img src="@/assets/imgs/icon_phone.png" alt="">
            <span>{{ i18n.phone }}</span>
          </div>
        </div>
        <div class="login-row">
          <div class="area" @click="isAreaView = true">
            <span>+{{ areaCode }}</span>
            <div class="area-down"></div>
          </div>
          <input
            type="number"
            v-model="phone"
            :placeholder="i18n.phone_number"
          />
        </div>
        <div class="login-row">
          <input
            type="number"
            v-model="code"
            :placeholder="i18n.captcha_code"
          />
          <div class="login-code" @click="onCaptcha">
            <img :src="captchaUrl" />
          </div>
        </div>
        <div class="btn" @click="sendBefore">{{ i18n.login }}</div>
      </div>
    </popup-warp>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
    <login-code
      v-if="isLoginCode"
      :loginType="loginType"
      @submit="loginBefore"
      @again="onBack"
      @back="onBack"
    ></login-code>
  </div>
</template>

<script>
import { PopupWarp } from "@/components/popup"
import { SelectArea } from "@/components/select";
import { generateUUID } from "@/utils/index";
import { baseURL } from "@/utils/http";
import {
  USER_CAPTCHA,
  LOGIN_CODE,
  SEND_CODE,
  USER_INFO,
  SEND_CODE_EMAIL,
  LOGIN_EMAIL
} from "@/apis/user";
import { LoginCode } from "@/components/login";
import md5 from "js-md5";
export default {
  props: {
    // 是否显示
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PopupWarp,
    SelectArea,
    LoginCode
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    },
    i18n() {
      return this.$t("login")
    }
  },
  data() {
    return {
      email: "",
      isAreaView: false,
      areaCode: "66",
      phone: "",
      code: "",
      captchaUrl: "",
      uuid: "",
      isLoginCode: false,
      loginType: "SMS"
    }
  },
  methods: {
    onReadMe() {
      const VUE_APP_PACT = `${process.env.VUE_APP_DOMAIN}/content/user_agreement.html`;
      window.open(VUE_APP_PACT);
    },
    onSelct(val) {
      this.areaCode = val;
    },
    onCaptcha() {
      this.code = "";
      this.uuid = generateUUID();
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`;
    },
    sendBefore() {
      if (this.loginType === "SMS") {
        this.onSendCode();
      } else {
        this.onSendCodeEmail();
      }
    },
    loginBefore(code) {
      if (this.loginType === "SMS") {
        this.onLogin(code);
      } else {
        this.onLoginEmail(code);
      }
    },
    onLogin(code) {
      this.$loading(true);
      this.$post(
        LOGIN_CODE,
        {
          mobile: this.areaCode + this.phone,
          verifyCode: code,
          areaCode: this.areaCode,
          registAndLoginType: 1
        },
        res => {
          console.log(res);
          this.$loading(false);
          if (res.token) {
            this.$store.commit("token", res.token);
            this.loadUser();
          } else {
            this.$toast(this.i18n.msg_fail_login);
          }
        },
        err => {
          console.log(err);
          this.$toast(err);
          this.$loading(false);
        }
      );
    },
    onSendCode() {
      let phone = this.phone;
      if (this.areaCode === "66") {
        let regex = /^(0)?[6-9]\d{8}$/ // 泰国手机号规则
        if (!regex.test(phone)) {
          this.$toast(this.i18n.phone_format_tips);
          return;
        }
        if (phone.startsWith('0')) { // 第一位是0的话, 删除0, 保持手机号账号统一
          phone = phone.substring(1);
        }
      } else {
        let regex = /^\d{6,}$/
        if (!regex.test(phone)) {
          this.$toast(this.i18n.phone_format_tips);
          return;
        }
      }
      this.$loading(true);
      this.$post(
        SEND_CODE,
        {
          mobile: this.areaCode + phone,
          uuid: this.uuid,
          code: this.code,
          useDebug: false
        },
        res => {
          console.log(res);
          this.$loading(false);
          this.isLoginCode = true;
        },
        err => {
          console.log(err);
          this.$loading(false);
          this.$toast(err);
          this.onCaptcha();
        }
      );
    },
    onBack() {
      this.isLoginCode = false;
      this.onCaptcha();
    },
    loadUser() {
      this.$loading(true);
      this.$get(
        USER_INFO,
        {},
        res => {
          this.$loading(false);
          if (res.user) {
            this.$store.commit("user", res.user);
            this.$toast(this.i18n.msg_success_login);
            this.isLoginCode = false
            this.currentValue = false
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser();
              })
              .catch(() => {
                this.$store.commit("token", null);
              });
          }
        },
        err => {
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null);
          });
        }
      );
    },
    onSendCodeEmail() {
      if (!this.email) {
        this.$toast(this.i18n.verification_email);
        return;
      }
      this.$loading(true);
      var timestamp = Math.floor(Date.now() / 1000);
      this.$get(
        SEND_CODE_EMAIL,
        {
          email: this.email,
          timestamp: timestamp,
          sign: md5(timestamp.toString().replaceAll("0", "8") + "GZzbjkj")
        },
        res => {
          console.log(res);
          this.$loading(false);
          this.isLoginCode = true;
        },
        err => {
          console.log(err);
          this.$loading(false);
          this.$toast(err);
        }
      );
    },
    onLoginEmail(code) {
      this.$loading(true);
      this.$post(
        LOGIN_EMAIL,
        {
          email: this.email,
          verifyCode: code
        },
        res => {
          console.log(res);
          this.$loading(false);
          if (res.token) {
            this.$store.commit("token", res.token);
            this.loadUser();
          } else {
            this.$toast(this.i18n.msg_fail_login);
          }
        },
        err => {
          console.log(err);
          this.$loading(false);
        }
      );
    }
  },
  mounted() {
    this.onCaptcha();
  }
}
</script>

<style lang="less">
.login-popup-warp {
  height: 602px;
  border-radius: 100px 100px 0 0;
  background-color: #fff;
  padding: 32px 48px;
  .login-popup-block {
    width: 112px;
    height: 8px;
    border-radius: 4px;
    margin: 0 auto 40px;
    background-color: #EBEBEB;
  }
  .login-popup-types {
    display: flex;
    padding-bottom: 20px;
    .login-popup-type {
      padding: 0 26px;
      border-radius: 20px;
      height: 72px;
      background: rgba(242, 252, 127, 0.3);
      display: flex;
      align-items: center;
      font-size: 28px;
      color: #000;
      img {
        height: 40px;
        display: block;
        margin: 0 20px 0 0;
      }
    }
  }
  .login-row {
    margin: 36px 0;
    height: 90px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 4px solid #EBEBEB;
    border-radius: 10px;
    padding: 0 20px;
    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 90px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }

    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: #000 transparent transparent;
    }

    .login-code {
      width: 180px;
      height: 60px;
      background-image: linear-gradient(
        to right,
        rgba(194, 194, 194, 1),
        rgba(252, 252, 252, 1)
      );
      // margin-right: 10px;

      img {
        width: 180px;
        height: 60px;
      }
    }
  }
}
</style>
